import React from 'react';
import LoadingOverlay from '../loadingoverlay/LoadingOverlay.js';
import Treestructure from './Treestructure.js';

const TreeView = ({ data = [], onNodeClick, selectedNodePath, loading = false, isFlat = false }) => {
  return (
    <div className="tree-view-wrapper" style={{ position: 'relative' }}>
      {data.length === 0 ? (
        <div className="no-data-message">No Data Found.</div>
      ) : (
        data.map((node, index) => (
          <Treestructure
            key={index}
            node={node}
            onNodeClick={onNodeClick}
            selectedPath={selectedNodePath}
            isFlat={isFlat}
          />
        ))
      )}
      {loading && <LoadingOverlay />}
    </div>
  );
};

export default TreeView;
